<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'checkout-venue-info',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
      venue: (state) => state.venue.current,
      booking: (state) => state.checkout.booking,
      date: (state) => state.date.current,
    }),
    venueLogoStyles() {
      const logo = this.venue.logo || 'https://s3.amazonaws.com/tablelist-assets/www-2/nightpro-widgets/tablelist-widget-logo.png'

      return {
        'background-image': `url("${logo}")`,
      }
    },
  },
  methods: {
    goToMapsUrl() {
      const address = (this.venue.location || {}).address || {}

      if (!address.address) return

      let baseUrl = 'https://www.google.com/maps/dir//'

      if (address.address) baseUrl += `+${address.address.replace(/ /g, '+')},`
      if (address.city) baseUrl += `+${address.city.replace(/ /g, '+')},`
      if (address.state) baseUrl += `+${address.state.replace(/ /g, '+')}`
      if (address.zip) baseUrl += `+${address.zip}`

      window.open(baseUrl)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CheckoutVenueInfo/index.vue